import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { contactStore } from "../../../stores/contactStore";
import { ContactStatus } from "@common/contracts";
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import { WithUser } from "common-frontend-components";
import Badge from '@mui/material/Badge';
import { IconButton } from "@mui/material";
import { adminLinks } from "../../../variables/adminRoutes";
export const ContactCircleNotificationsIcon = WithUser(() => {
    const contacts = contactStore.useContacts();
    const pending = useMemo(() => contacts.filter(i => i.status === ContactStatus.pending), [contacts]);
    if (pending.length === 0)
        return _jsx(_Fragment, {}, void 0);
    return (_jsx(IconButton, { "aria-label": "pending-contacts-notification", onClick: adminLinks.contactsManagement, children: _jsx(Badge, { badgeContent: pending.length, max: 99, color: "primary", children: _jsx(CircleNotificationsIcon, { color: "action" }, void 0) }, void 0) }, void 0));
});
//# sourceMappingURL=ContactCircleNotificationsIcon.js.map